<template>
    <div>
        <CCol sm="12">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
    
                <CCard class="p-2" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12" md="4" lg="2" class="text-center p-2" v-for="button in buttons" :key="button.value">
                            <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2" style="text-wrap:nowrap">
                                {{ button.label }}
                            </div>
                        </CCol>
    
                    </CRow>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div v-if="activeButton === 'payroll'">
                        <CCol sm="12" md="4" lg="2" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="text-right">
                                        <CButton class="btn-border-blue font-color-0B63F6" @click="openRunPayment"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Run Payment</CButton>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
    
                        <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
                            <template v-slot:No="{ row }">
                                                                                                                                              <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Year="{ row }">
    <label class="custom-12px-500">{{ row.Year }}</label>
</template>

<template v-slot:Month="{ row }">
    <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Month }}</label>
</template>

<template v-slot:PayrollDate="{ row }">
    <label class="custom-12px-500">{{ 'row.Payroll Date' }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500">{{ row.Status }}</label>
</template>

<template v-slot:Remarks="{ row }">
    <label class="custom-12px-500">{{ row.Remarks }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex"> <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openUserSalary(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/icondetail.png')" alt="View" style="cursor: pointer;width:30px" @click="openUserSalary(row.Index)" class="ml-2" />
    </div>
</template>
                        </v-client-table>
                        <div v-else class="no-data-message text-center" style="margin:10%">
                            <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                            <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                            <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                            </div>
                    </div>


                    <div v-if="activeButton === 'salary'">

                        <div v-if="listSalary===true">
                            <v-client-table :data="salaryTableData" :columns="columnsSalary" :options="options" class="custom-table" v-if="salaryTableData.length > 0">
<template v-slot:No="{ row }">
    <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Name="{ row }">
    <label class="custom-12px-500">{{ row.Name }}</label>
</template>

<template v-slot:Employee No="{ row }">
    <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.EmployeeNo }}</label>
</template>

<template v-slot:Designation="{ row }">
    <label class="custom-12px-500">{{ row.Designation }}</label>
</template>

<template v-slot:DateJoining="{ row }">
    <label class="custom-12px-500">{{ row.DateJoining }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex">
        <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="opendetailSalary(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/edit 2.png')" alt="View" style="cursor: pointer;width:30px" @click="openeditsalary()" class="ml-2" />
    </div>
</template>
                            </v-client-table>
                                    <div v-else class="no-data-message text-center" style="margin:10%">
                            <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                            <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                            <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                            </div>
                        </div>

                        <div v-if="showdetailsalary===true">
                            <CCol sm="12" @click="GoToSettingEmployee()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" />
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-18px-500 font-color-171717 mt-2">Nor Adzin Md Noor</h3>
                                <hr class="custom-hr" />
                            </CCol>
                           
                            <CCard class="custom-border-radius-16px" style="border:none;">
                                <CRow class="m-2">
                                    <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttonsEmployeeSalary" :key="button.value">
                                        <div :class="{'grey-background': activeButtonEmployeeSalary === button.value, 'font-color-98A2B3': activeButtonEmployeeSalary !== button.value}" @click="setActiveButtonEmployeeSalary(button.value)" class="p-2">
                                            {{ button.label }}
                                        </div>
                                    </CCol>
                    
                                </CRow>
                            </CCard>
                           
    
                            <div v-if="activeButtonEmployeeSalary === 'SalaryDetails'">
                                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                                    <div class="p-2">
                                       
                                        <table class="table table-responsive-sm">
                                            <thead>
                                                <th>Net Salary</th>
                                                <th>Gross Salary</th>
                                                <th>Deduction</th>
                                                <th>Company Contribution</th>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>RM 2,000.00</td>
                                                    <td>RM 2,000.00</td>
                                                    <td>RM 0.00</td>
                                                    <td>RM 0.00</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <hr class="custom-hr" />
                                        <h3 class="custom-16px-600 font-color-171717 mt-4 mb-4">Gross Salary</h3>
                                        <CRow>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Basic Salary</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Salary Unit</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Salary Type</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Salary</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Advance Salary</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Phone Allowance</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Substance Allowance</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Extra Responsibility Allowance</label>
                                                <CInput type="text" />
                                            </CCol>
                                        </CRow>

                                        <h3 class="custom-16px-600 font-color-171717 mt-4 mb-4">Item Additional</h3>
                                        <CRow>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Travelling Allowance</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Child Care Allowance</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Gift</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Reward</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Parking Allowance</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Meal Allowance</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Subsidies</label>
                                                <CInput type="text" />
                                            </CCol>
                                        </CRow>

                                        <h3 class="custom-16px-600 font-color-171717 mt-4 mb-4">Deduction</h3>
                                        <CRow>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">EPF Employee</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">SOCSO Employee</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="3">
                                                
                                                <label class="custom-14px-500 font-color-171717">EIS Employee</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">PCB 39</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">PCB 38</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="2">
                                                <label class="custom-14px-500 font-color-171717">Advance</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="2">
                                                <label class="custom-14px-500 font-color-171717">Unpaid Leave</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="2">
                                                <label class="custom-14px-500 font-color-171717">Other Deduction</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Zakat</label>
                                                <CInput type="text" />
                                            </CCol>
                                        </CRow>

                                        <h3 class="custom-16px-600 font-color-171717 mt-4 mb-4">Company Contribution</h3>
                                        <CRow>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">EPF Employer</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">SOCSO Employer</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">EIS Employer</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">HRDF</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Medical Card</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Group Term Life</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Medical Company</label>
                                                <CInput type="text" />
                                            </CCol>
                                        </CRow>
                    
                    
                                    </div>
                                </CCard>
                            </div>
                    
                            <div v-if="activeButtonEmployeeSalary === 'PersonalDetails'">
                                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                                    <div class="p-2">
                                       
                                      
                                        <h3 class="custom-16px-600 font-color-171717 mb-4">Personal Details</h3>
                                        <CRow>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Name</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Company</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Employee No</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Department</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">NRIC</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Designation</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Date of Birth</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Date Joining</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Employee Status</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Include in Payroll / Payment</label>
                                                <CInput type="text" />
                                            </CCol>
                                           <CCol sm="12">
                                            <hr class="custom-hr" />
                                           </CCol>
                                        </CRow>

                                        <h3 class="custom-16px-600 font-color-171717 mt-4 mb-4">Contribution Details</h3>
                                        <CRow>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">SOCSO/EIS No</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Deduction SOCSO/EIS</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">EPF No</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Deduction EPF Employee</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">EPF Contribution Start Date</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Deduction EPF Employe</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Income Tax No</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Deduction HRDF</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="12">
                                            <hr class="custom-hr" />
                                           </CCol>
                                        </CRow>

                                        <h3 class="custom-16px-600 font-color-171717 mt-4 mb-4">Bank Details</h3>
                                        <CRow>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Bank</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Account No</label>
                                                <CInput type="text" />
                                             
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Account Type</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Account Status</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Branch</label>
                                                <CInput type="text" />
                                            </CCol>
                                        </CRow>
                    
                    
                                    </div>
                                </CCard>
                            </div>
    
                        </div>

                        <div v-if="showeditsalary===true">
                            <CCol sm="12" @click="GoToSettingEmployee()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" />
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
                            <CCol sm="12">
                                <CRow>
                                <CCol sm="8">

<h3 class="custom-18px-500 font-color-171717 mt-2">Nor Adzin Md Noor</h3>
</CCol> 
<CCol sm="4" class="text-right">  

    <CButton class="bg-0B63F6 font-color-0B63F6 ml-2 text-right text-white" style="border-radius:9px">Recalculate</CButton>
    <CButton class="btn-border-blue font-color-0B63F6 ml-2">Save Changes</CButton>
</CCol>
</CRow>
                               
                                        <hr class="custom-hr" />
                                        <h3 class="custom-16px-600 font-color-171717 mt-2">Salary Type</h3>
                                        <CRow>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Basic Salary</label>
                                                <CInput type="text" />
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Salary</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                            </CCol>
                                            <CCol sm="4">
                                            <CRow>
                                                <CCol sm="10">
                                                    <label class="custom-14px-500 font-color-171717">Salary Type</label>
                                                </CCol>
                                                <CCol sm="2" @click="OpenSalaryTypeInfo">
                                                    <img src="../assets/img/info-circle.png" width="20px"/>
                                                </CCol>
                                            </CRow>
                                               
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Setting</label>
                                                <CRow>
                                                    <CCol sm="10">
                                                        <label class="font-color-171717 font-inter custom-14px-500">Calculate In Payment</label>
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right" size="sm" shape="pill" color="info" data-on="On" data-off="Off" />
                                                    </CCol>

                                                    <CCol sm="10">
                                                        <label class="font-color-171717 font-inter custom-14px-500">SOSCO Deduction</label>
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right" size="sm" shape="pill" color="info" data-on="On" data-off="Off" />
                                                    </CCol>

                                                    <CCol sm="10">
                                                        <label class="font-color-171717 font-inter custom-14px-500">EIS Deduction</label>
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right" size="sm" shape="pill" color="info" data-on="On" data-off="Off" />
                                                    </CCol>
                                                </CRow>
                                               
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-16px-600 font-color-171717">HRDF Setting</label>
                                                <br />
                                                <label class="custom-14px-500 font-color-171717">Employer Rate</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="5">
                                                <label class="custom-14px-500 font-color-171717">Other Remarks</label>
                                                <CTextarea rows="3"></CTextarea>
                                            </CCol>

                                            <CCol sm="12">
                                                <label class="custom-16px-600 font-color-171717">EPF Setting</label>
                                            </CCol>

                                            <CCol sm="3">
                                                
                                                <label class="custom-14px-500 font-color-171717">Calculation Method</label>
                                               <CSelect></CSelect>
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Employee Rate</label>
                                                <CSelect>
<template #append-content>
     %
</template>
                                                </CSelect>
                                            </CCol>
                                            <CCol sm="2">
                                                <label class="custom-14px-500 font-color-171717">Other</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="2">
                                                <label class="custom-14px-500 font-color-171717">Employer Rate</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="2">
                                                <label class="custom-14px-500 font-color-171717">Other</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>

                                            <CCol sm="12">
                                                <label class="custom-16px-600 font-color-171717">Additional Item</label>
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Advance Salary</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                                <div class="font-color-171717">
                                                <input type="checkbox" class="m-2"/>EPF
                                                <input type="checkbox" class="m-2"/>SOCSO
                                                <input type="checkbox" class="m-2"/>EIS
                                                <input type="checkbox" class="m-2"/>PCB39
                                                <input type="checkbox" class="m-2"/>Fixed
                                            </div>
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Subsistance Allowance</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                                <div class="font-color-171717">
                                                <input type="checkbox" class="m-2"/>EPF
                                                <input type="checkbox" class="m-2"/>SOCSO
                                                <input type="checkbox" class="m-2"/>EIS
                                                <input type="checkbox" class="m-2"/>PCB39
                                                <input type="checkbox" class="m-2"/>Fixed
                                                </div>
                                            </CCol>

                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">Extra Responbility Allowance</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                                <div class="font-color-171717">
                                                <input type="checkbox" class="m-2"/>EPF
                                                <input type="checkbox" class="m-2"/>SOCSO
                                                <input type="checkbox" class="m-2"/>EIS
                                                <input type="checkbox" class="m-2"/>PCB39
                                                <input type="checkbox" class="m-2"/>Fixed
                                            </div>
                                            </CCol>
                                            <CCol sm="6">
                                                <label class="custom-14px-500 font-color-171717">BIK/VOLA</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                                <div class="font-color-171717">
                                                <input type="checkbox" class="m-2"/>EPF
                                                <input type="checkbox" class="m-2"/>SOCSO
                                                <input type="checkbox" class="m-2"/>EIS
                                                <input type="checkbox" class="m-2"/>PCB39
                                                <input type="checkbox" class="m-2"/>Fixed
                                                </div>
                                            </CCol>
                                            <CCol sm="12">
                                                <label class="custom-16px-600 font-color-171717 mt-3">Deduction Item</label>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">EPF Employee</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">SOSCO Employee</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="4">
                                                <CRow>
                                                    <CCol sm="10"> <label class="custom-14px-500 font-color-171717">EIS Employee</label></CCol>
                                                    <CCol sm="2"><img src="../assets/img/info-circle.png" width="20px"/></CCol>
                                                    </CRow>

                                               
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Advance</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                                <div class="font-color-171717">
                                                <input type="checkbox" class="m-2"/>EPF
                                                <input type="checkbox" class="m-2"/>SOCSO
                                                <input type="checkbox" class="m-2"/>EIS
                                                <input type="checkbox" class="m-2"/>PCB39
                                                <input type="checkbox" class="m-2"/>Fixed
                                                </div>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Unpaid Leave</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                                <div class="font-color-171717">
                                                <input type="checkbox" class="m-2"/>EPF
                                                <input type="checkbox" class="m-2"/>SOCSO
                                                <input type="checkbox" class="m-2"/>EIS
                                                <input type="checkbox" class="m-2"/>PCB39
                                                <input type="checkbox" class="m-2"/>Fixed
                                                </div>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">PCB 39</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                               
                                            </CCol>

                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">PCB 38</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                                <div class="font-color-171717">
                                                <input type="checkbox" class="m-2"/>EPF
                                                <input type="checkbox" class="m-2"/>SOCSO
                                                <input type="checkbox" class="m-2"/>EIS
                                                <input type="checkbox" class="m-2"/>PCB39
                                                <input type="checkbox" class="m-2"/>Fixed
                                                </div>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Zakat</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">Other Deduction</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                                <div class="font-color-171717">
                                                <input type="checkbox" class="m-2"/>EPF
                                                <input type="checkbox" class="m-2"/>SOCSO
                                                <input type="checkbox" class="m-2"/>EIS
                                                <input type="checkbox" class="m-2"/>PCB39
                                                <input type="checkbox" class="m-2"/>Fixed
                                                </div>
                                            </CCol>

                                            <CCol sm="12">
                                                <label class="custom-16px-600 font-color-171717 mt-3">Company Contribution</label>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">EPF Employer</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">SOSCO Employer</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="4">
                                                <label class="custom-14px-500 font-color-171717">EIS Employer</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                >
<template #append-content>
     %
</template>
                                                </CInput>
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Medical Card</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Group Term Life</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">Medical Company</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                            </CCol>
                                            <CCol sm="3">
                                                <label class="custom-14px-500 font-color-171717">HRDF</label>
                                                <CInput
                                                    type="email"
                                                    autocomplete="email"
                                                    prepend="RM"
                                                >
                                                </CInput>
                                            </CCol>


                                        </CRow>


                            </CCol>
                    
                        </div>
    
                     
                    </div>

                    <div v-if="activeButton ==='task'">
                        <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
<template v-slot:No="{ row }">
    <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Year="{ row }">
    <label class="custom-12px-500">{{ row.Year }}</label>
</template>

<template v-slot:Month="{ row }">
    <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Month }}</label>
</template>

<template v-slot:PayrollDate="{ row }">
    <label class="custom-12px-500">{{ 'row.Payroll Date' }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500">{{ row.Status }}</label>
</template>

<template v-slot:Remarks="{ row }">
    <label class="custom-12px-500">{{ row.Remarks }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex"> <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openUserSalary(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/icondetail.png')" alt="View" style="cursor: pointer;width:30px" @click="openUserSalary(row.Index)" class="ml-2" />
    </div>
</template>
                        </v-client-table>
                        <div v-else class="no-data-message text-center" style="margin:10%">
                            <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                            <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                            <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                            </div>
                    </div>

                    <div v-if="activeButton ==='report'">
                        <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
<template v-slot:No="{ row }">
    <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Year="{ row }">
    <label class="custom-12px-500">{{ row.Year }}</label>
</template>

<template v-slot:Month="{ row }">
    <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Month }}</label>
</template>

<template v-slot:PayrollDate="{ row }">
    <label class="custom-12px-500">{{ 'row.Payroll Date' }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500">{{ row.Status }}</label>
</template>

<template v-slot:Remarks="{ row }">
    <label class="custom-12px-500">{{ row.Remarks }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex"> <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openUserSalary(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/icondetail.png')" alt="View" style="cursor: pointer;width:30px" @click="openUserSalary(row.Index)" class="ml-2" />
    </div>
</template>
                        </v-client-table>
                        <div v-else class="no-data-message text-center" style="margin:10%">
                            <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                            <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                            <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                            </div>
                    </div>

                    <div v-if="activeButton ==='summary'">
                        <v-client-table :data="payslipDetailTableData" :columns="columnsPayslipWithAction" :options="options" class="custom-table" v-if="payslipDetailTableData.length > 0">

<template v-slot:Action="{ row }">
    <div class="d-flex"> <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openUserSalary(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/icondetail.png')" alt="View" style="cursor: pointer;width:30px" @click="openUserSalary(row.Index)" class="ml-2" />
    </div>
</template>
                </v-client-table>
                <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                </div>
                    </div>
                   

                </CCard>
            </CCol>
    
        </CCol>

        <div v-if="ViewRunPayment" class="popup-all backdrop-all">
            <div class="popup-all1">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">  Run Payment</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closeRunPayment" /></CCol>
                </CRow>
    
                <div class="p-2">
                    <CRow>

                        <CCol sm="12">
                            <h3 class="custom-14px-500 font-color-171717">Payroll Information</h3>
                        </CCol>
                        <CCol sm="4" class="mt-2">
                            <h3 class="custom-14px-500 font-color-171717">Year</h3>
                            <CInput type="text" />
                        </CCol>
    
                        <CCol sm="4" class="mt-2">
                            <h3 class="custom-14px-500 font-color-171717">Month</h3>
                            <CInput type="text" />
                        </CCol>
                        <CCol sm="4" class="mt-2">
                            <h3 class="custom-14px-500 font-color-171717">Payment Date</h3>
                            <CInput type="text" />
                        </CCol>
                        <CCol sm="12" class="mt-2 mb-3">
                            <h3 class="custom-14px-500 font-color-171717">Remarks</h3>
                            <CTextarea rows="5"/>
                            <hr class="custom-hr" />
                            <h3 class="custom-14px-500 font-color-171717">Include Into Payroll</h3>
                        </CCol>
                        <CCol sm="10" class="mt-2">
                            <h3 class="custom-14px-500 font-color-171717">Claim Financial</h3>
                        </CCol>
                        <CCol sm="2" class="mt-2">
                            <CSwitch class="mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                        </CCol>
                        <CCol sm="10" class="mt-2">
                            <h3 class="custom-14px-500 font-color-171717">Claim Overtime</h3>
                        </CCol>
                        <CCol sm="2" class="mt-2">
                            <CSwitch class="mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                        </CCol>
                        <CCol sm="10" class="mt-2">
                            <h3 class="custom-14px-500 font-color-171717">Unpaid Leave</h3>
                        </CCol>
                        <CCol sm="2" class="mt-2">
                            <CSwitch class="mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                        </CCol>
                        <CCol sm="10" class="mt-2">
                            <h3 class="custom-14px-500 font-color-171717">Lateness</h3>
                        </CCol>
                        <CCol sm="2" class="mt-2">
                            <CSwitch class="mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                        </CCol>
                    </CRow>
                    <CRow class="mt-4">
                        <CCol sm="6"> <CButton class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="" block>Cancel</CButton></CCol>
                        <CCol sm="6">
                            <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white border-half" block>Generate</CButton>
                        </CCol>
                        </CRow>
    
    
                </div>
            </div>
        </div>

        <div v-if="OpenUserPayment" class="popup-all backdrop-all">
            <div class="popup-all2">
                
                <CRow>
                    <CCol sm="1"><img src="../assets/img/round-calendar.png" width="50px"/></CCol>
                    <CCol sm="10">
                        <h3 class="custom-18px-600 font-inter text-left">August 2024</h3>
                        <p class="custom-16px-400 font-inter text-left">31 Aug 2024</p>
                    
                    </CCol>
                    <CCol sm="1">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupUserPayment" />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="4">
                            <CCard class="custom-border-radius-16px custom-info-blue text-left mb-0" style="border:none;text-align:left">
                               <label class="font-color-003CC5 custom-16px-500 font-inter text-left">Salary Payroll</label> 
                            </CCard>
                            <CRow>
                                <CCol sm="4">
                                    <div class="text-center mt-2">
                                        <img src="../assets/img/menu-tab.png" style="max-width:40px"/>
                                        <br />
                                      <img src="../assets/img/line-menu.png" class="text-center"/>
                                      <br />
                                      <img src="../assets/img/menu-tab.png" style="max-width:40px"/>
                                      <br />
                                      <img src="../assets/img/line-menu.png" class="text-center"/>
                                      <br />
                                      <img src="../assets/img/menu-tab.png" style="max-width:40px"/>
                                      <br />
                                    </div>
                                   
                      
                                </CCol>
                                <CCol sm="8">
                                    <div class="mt-2">
                                        <span class="custom-12px-500 font-color-98A2B3">Step 1</span>
                                        <label class="custom-16px-500">Update & Review</label>
                                        <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">Completed</label>
                                        <br />
                                        <span class="custom-12px-500 font-color-98A2B3">Step 2</span>
                                        <br />
                                        <label class="custom-16px-500">Approval</label>
                                        <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">Completed</label>
                                        <br />
                                        <span class="custom-12px-500 font-color-98A2B3">Step 3</span>
                                        <br />
                                        <label class="custom-16px-500">Payment & Close</label>
                                        <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">Completed</label>
                                   
                                       
                                    </div>
                                   
                                </CCol>
                            </CRow>
                          
                         
                        </CCol>
                        <CCol sm="8">
                            <CCard class="custom-border-radius-16px custom-info-blue text-left" style="border:none;text-align:left">
                                <label class="font-color-003CC5 custom-16px-500 font-inter text-left">Total Payable</label>
                            </CCard>
                            <CRow>
                                <CCol sm="4">
                                    <label class="custom-16px-500">EPF</label>
                                    <CInput type="text" />
                                    <label class="custom-16px-500">HRDF</label>
                                    <CInput type="text" />
                                    <label class="custom-16px-500">Zakat</label>
                                    <CInput type="text" />
                                </CCol>
                                <CCol sm="4">
                                    <label class="custom-16px-500">SOCSO</label>
                                    <CInput type="text" />
                                    <label class="custom-16px-500">TAX</label>
                                    <CInput type="text" />
                                    <label class="custom-16px-500">Staff Salary</label>
                                    <CInput type="text" />
                                </CCol>
                                <CCol sm="4">
                                    <label class="custom-16px-500">EIS</label>
                                    <CInput type="text" />
                                    <label class="custom-16px-500">Insurance/Medical</label>
                                    <CInput type="text" />
                                </CCol>
                            </CRow>
                            
                            </CCol>
                        <CCol sm="12" class="text-center">
                                <CAlert show color="danger">
                                    <strong class="text-danger custom-18px-500">Grand Total Payment</strong>
                                    <br />
                                    <strong class="text-danger custom-18px-700">RM 4,548.05</strong>
                                </CAlert>
                        </CCol>
                        <CCol sm="6">
                            <CCard class="custom-border-radius-16px custom-info-blue text-left" style="border:none;text-align:left">
                                <label class="font-color-003CC5 custom-16px-500 font-inter text-left">List Statutory</label>
                            </CCard>
                            <CRow>
                                <CCol sm="4">
                                    <label class="custom-16px-500">EPF</label>
                                    <CInput type="text" />
                                    <label class="custom-16px-500">EIS</label>
                                    <CInput type="text" />
                                </CCol>
                                <CCol sm="4">
                                    <label class="custom-16px-500">PCB</label>
                                    <CInput type="text" />
                                    <label class="custom-16px-500">SOCSO + EIS</label>
                                    <CInput type="text" />
                                </CCol>
                                <CCol sm="4">
                                    <label class="custom-16px-500">SOCSO</label>
                                    <CInput type="text" />
                                </CCol>
                            </CRow>
                           
                        </CCol>
                        <CCol sm="6">
                            <CCard class="custom-border-radius-16px custom-info-blue text-left" style="border:none;text-align:left">
                                <label class="font-color-003CC5 custom-16px-500 font-inter text-left">Pay Satutory & Salary</label>
                            </CCard>
                            <label class="custom-14px-500 font-color-171717">Select Bank</label>
                                    <CSelect/>
                                    <label class="custom-14px-500 font-color-171717">Bank File Available</label>
                                    <CInput type="text" />
                        </CCol>
                                      </CRow>

               


    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow class="mt-3"> <CCol sm="4">
                            <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white" block> <img src="../assets/img/printer.png" width="30px" class="mr-2"/>Export Bank File</CButton>
                        </CCol>
                        <CCol sm="4">
                            <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white" block> <img src="../assets/img/printer.png" width="30px" class="mr-2"/>Export Playslip</CButton>
                        </CCol>
                        <CCol sm="4">
                            <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white" block @click="openViewPayslip"> <img src="../assets/img/view.png" width="30px" class="mr-2"/>View Playslip</CButton>
                        </CCol>
                        </CRow>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>

        <div v-if="OpenPayslip" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CCol sm="12">
                    <div class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupUserPayment" />
                    </div>
                      
                    </CCol>

                <CCard class="p-2" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12" md="4" lg="2" class="text-center p-2" v-for="button in buttonsDetails" :key="button.value">
                            <div :class="{'blue-background': activeButtonDetails === button.value, 'blue-text': activeButtonDetails !== button.value}" @click="setActiveButtonDetails(button.value)" class="p-2" style="text-wrap:nowrap">
                                {{ button.label }}
                            </div>
                        </CCol>
    
                    </CRow>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div v-if="activeButtonDetails === 'payroll-detail'">
                        <CRow>
                    <CCol sm="1"><img src="../assets/img/round-calendar.png" width="50px"/></CCol>
                    <CCol sm="10">
                        <h3 class="custom-18px-600 font-inter text-left">August 2024</h3>
                        <p class="custom-16px-400 font-inter text-left">31 Aug 2024</p>
                    
                    </CCol>
                </CRow>
                <v-client-table :data="payrollDetailTableData" :columns="columnsDetail" :options="options" class="custom-table" v-if="payrollDetailTableData.length > 0">
<template v-slot:No="{ row }">
    <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Name="{ row }">
    <label class="custom-12px-500">{{ row.Name }}</label>
</template>

<template v-slot:Salary="{ row }">
    <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Salary }}</label>
</template>

<template v-slot:Additional="{ row }">
    <label class="custom-12px-500">{{ row.Additional }}</label>
</template>

<template v-slot:Gross="{ row }">
    <label class="custom-12px-500">{{ row.Gross }}</label>
</template>

<template v-slot:Deduction="{ row }">
    <label class="custom-12px-500">{{ row.Deduction }}</label>
</template>

<template v-slot:Contribution="{ row }">
    <label class="custom-12px-500">{{ row.Contribution }}</label>
</template>
                </v-client-table>
                <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                </div>
                <h3 class="custom-16px-600 mt-3">Salary Payroll Approval</h3>
                <CRow class="mt-3">
                    <CCol sm="1"><img src="../assets/img/userApproval.png" width="50px"/></CCol>
                    <CCol sm="11">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-600 font-inter text-left">Nor Adzrin Md Nor</h3>
                                <CRow>
                                    <CCol sm="4">
                                        <p class="custom-16px-400 font-inter text-left">Supervisor Level 1</p>
                                    </CCol>
                                    <CCol sm="8">
                                        <div class="custom-bg-D1FADF font-color-12B76A">
                                    Closed
                                </div>
                                    </CCol>
                                </CRow>
                      
                            </CCol>
                            </CRow>
                    </CCol>
                </CRow>
                        </div>
                        <div v-if="activeButtonDetails === 'payslip-detail'">
                            <v-client-table :data="payslipDetailTableData" :columns="columnsPayslip" :options="options" class="custom-table" v-if="payslipDetailTableData.length > 0">
<template v-slot:No="{ row }">
    <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Name="{ row }">
    <label class="custom-12px-500">{{ row.Name }}</label>
</template>

<template v-slot:Salary="{ row }">
    <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Salary }}</label>
</template>

<template v-slot:Additional="{ row }">
    <label class="custom-12px-500">{{ row.Additional }}</label>
</template>

<template v-slot:Gross="{ row }">
    <label class="custom-12px-500">{{ row.Gross }}</label>
</template>

<template v-slot:Deduction="{ row }">
    <label class="custom-12px-500">{{ row.Deduction }}</label>
</template>

<template v-slot:Contribution="{ row }">
    <label class="custom-12px-500">{{ row.Contribution }}</label>
</template>
                </v-client-table>
                <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                </div>
                <h3 class="custom-16px-600 mt-3">Salary Payroll Approval</h3>
                <CRow class="mt-3">
                    <CCol sm="1"><img src="../assets/img/userApproval.png" width="50px"/></CCol>
                    <CCol sm="11">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-600 font-inter text-left">Nor Adzrin Md Nor</h3>
                                <CRow>
                                    <CCol sm="4">
                                        <p class="custom-16px-400 font-inter text-left">Supervisor Level 1</p>
                                    </CCol>
                                    <CCol sm="8">
                                        <div class="custom-bg-D1FADF font-color-12B76A">
                                    Closed
                                </div>
                                    </CCol>
                                </CRow>
                      
                            </CCol>
                            </CRow>
                    </CCol>
                </CRow>      
            </div>
                        
                        </CCard>

                
              
            </div>
        </div>

        <div v-if="isPopupSalaryInfoType" class="popup-all backdrop-all">
            <div class="popup-all1" style="max-width:400px">
                <!-- Popup content -->
                <div class="text-left p-0">
                    <CRow>
                        <CCol sm="10">
                            <h3 class="custom-18px-600 font-color-171717 text-left mt-3">
                        Salary
                    </h3>
                        </CCol>
                        <CCol sm="2">
                            <div class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closeInfoSalaryType" />
                    </div>
                        </CCol>
                        </CRow>
                   
                    <p class="custom-14px-400 text-danger p-0">RM 2000.00</p>
                    <p class="custom-18px-400 font-color-98A2B3 p-0">Amount of Basic Salary <strong class="text-black">RM 2000.00 </strong><br />
Salary Unit <strong class="text-black">1 Month</strong></p>  </div>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import { CTextarea } from "@coreui/vue";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal
    },

    data() {
        return {
            activeButton: 'salary', // Default active button
            buttons: [
                { value: 'payroll', label: 'Salary Payroll List', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'salary', label: 'Employee Salary Table', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'task', label: 'Task', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'report', label: 'Report', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'summary', label: 'Summary', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],
            columns: [
                'No',
                'Year',
                'Month',
                'Payroll Date',
                'Status',
                'Remarks',
                'Action'
            ],
            allTableData: [
                { No: 1, Year: '2024', 'Month': 'August', 'Payroll Date': '25 May 2024', 'Status': 'Closed', 'Remarks': '' },
                { No: 2, Year: '2024', 'Month': 'August', 'Payroll Date': '25 May 2024', 'Status': 'Closed', 'Remarks': '' },
                { No: 3, Year: '2024', 'Month': 'August', 'Payroll Date': '25 May 2024', 'Status': 'Closed', 'Remarks': '' }
            ], // Data for the leave table
            columnsDetail: [
                'No',
                'Name',
                'Salary',
                'Additional',
                'Gross',
                'Deduction',
                'Contribution'
            ],
            payrollDetailTableData: [
                { No: 1, Name: 'Ahmad Firdaus Zuhri', Salary: 'RM 3000', Additional: 'RM 100', 'Gross': 'RM 1500', 'Deduction': 'RM 50', 'Contribution': 'RM 2,000.00' },
                {
                    No: 2,
                    Name: 'Ahmad Firdaus Zuhri',
                    Salary: 'RM 3000',
                    Additional: 'RM 100',
                    'Gross': 'RM 1500',
                    'Deduction': 'RM 50',
                    'Contribution': 'RM 2,000.00'
                },
                { No: 3, Name: 'Ahmad Firdaus Zuhri', Salary: 'RM 3000', Additional: 'RM 100', 'Gross': 'RM 1500', 'Deduction': 'RM 50', 'Contribution': 'RM 2,000.00' }
            ], // Data for the leave table
            options: {
                perPage: 5,
                pagination: true,
                searchable: false,
                filterable: false
            },

            OpenUserPayment: false,
            OpenPayslip: false,
            activeButtonDetails: 'payroll-detail',
            buttonsDetails: [
                { value: 'payroll-detail', label: 'Payroll', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'payslip-detail', label: 'Payslip', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],

            ViewRunPayment: false,
            columnsPayslip: [
                'No',
                'Name',
                'Salary',
                'Additional',
                'Gross',
                'Deduction',
                'Contribution',
                'EPF',
                'SOCSO',
                'EIS',
                'PCB',
                'EPFCmpny',
                'SOCSOCmpny',
                'EISCmpny',
                'PCBCmpny',


            ],
            columnsPayslipWithAction: [
                'No',
                'Name',
                'Salary',
                'Additional',
                'Gross',
                'Deduction',
                'Contribution',
                'EPF',
                'SOCSO',
                'EIS',
                'PCB',
                'EPFCmpny',
                'SOCSOCmpny',
                'EISCmpny',
                'PCBCmpny',
                'Action'


            ],
            payslipDetailTableData: [
                { No: 1, Name: 'Ahmad Firdaus Zuhri', Salary: 'RM 3000', Additional: 'RM 100', 'Gross': 'RM 1500', 'Deduction': 'RM 50', 'Contribution': 'RM 2,000.00', EPF: '0', SOCSO: '0', EIS: '0', PCB: '0', EPFCmpny: '0', SOCSOCmpny: '0', EISCmpny: '0', PCBCmpny: '0', 'Net Salary': 'RM3000', Status: 'Closed' },
                { No: 2, Name: 'Ahmad Firdaus Zuhri', Salary: 'RM 3000', Additional: 'RM 100', 'Gross': 'RM 1500', 'Deduction': 'RM 50', 'Contribution': 'RM 2,000.00', EPF: '0', SOCSO: '0', EIS: '0', PCB: '0', EPFCmpny: '0', SOCSOCmpny: '0', EISCmpny: '0', PCBCmpny: '0', 'Net Salary': 'RM3000', Status: 'Closed' },
                { No: 3, Name: 'Ahmad Firdaus Zuhri', Salary: 'RM 3000', Additional: 'RM 100', 'Gross': 'RM 1500', 'Deduction': 'RM 50', 'Contribution': 'RM 2,000.00', EPF: '0', SOCSO: '0', EIS: '0', PCB: '0', EPFCmpny: '0', SOCSOCmpny: '0', EISCmpny: '0', PCBCmpny: '0', 'Net Salary': 'RM3000', Status: 'Closed' }
            ], // Data for the leave table

            columnsSalary: [
                'No',
                'Name',
                'Employee No',
                'Designation',
                'Date Joining',
                'Status',
                'Action'
            ],
            salaryTableData: [{
                No: 1,
                Name: 'Ahmad Firdaus Zuhri',
                'Employee No': 'F94000',
                Designation: 'Director',
                'Date Joining': '24 feb 2021',
                Status: 'Employed – Not Applicable',
            }],
            listSalary: true,
            showdetailsalary: false,
            buttonsEmployeeSalary: [
                { value: 'SalaryDetails', label: 'Salary Details', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'PersonalDetails', label: 'Personal Details', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],
            activeButtonEmployeeSalary: "SalaryDetails",
            showeditsalary: false,
            isPopupSalaryInfoType: false


        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {

            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        openUserSalary() {
            this.OpenUserPayment = true;
        },
        openViewPayslip() {
            this.OpenUserPayment = false;
            this.OpenPayslip = true;
        },
        closePopupUserPayment() {
            this.OpenUserPayment = false;
            this.OpenPayslip = false;
        },
        setActiveButtonDetails(buttonValue) {
            this.activeButtonDetails = buttonValue;
        },
        closeRunPayment() {
            this.ViewRunPayment = false;
        },
        openRunPayment() {
            this.ViewRunPayment = true;
        },
        opendetailSalary() {
            this.showdetailsalary = true;
            this.listSalary = false;
        },
        setActiveButtonEmployeeSalary(buttonValue) {
            this.activeButtonEmployeeSalary = buttonValue;
        },
        openeditsalary() {
            this.showeditsalary = true;
            this.listSalary = false;
        },
        GoToSettingEmployee() {
            this.listSalary = true;
            this.showdetailsalary = false;
            this.showeditsalary = false;
        },
        OpenSalaryTypeInfo()
        {
            this.isPopupSalaryInfoType = true;
        },
        closeInfoSalaryType()
        {
            this.isPopupSalaryInfoType = false;
        }



    }

};
</script>